import angular from 'angular'

angular.module('nominas.carganominaasalariados')
  .service('NominasCargaNominaAsalariados', NominasCargaNominaAsalariados);

function NominasCargaNominaAsalariados($api, $schema) {
  this.catalogo = catalogo;
  this.guardar = guardar;

  function catalogo(ID_Empresa) {
    return $api.get('kendu/nominas/cargaNominaAsalariados/catalogo', {
        empresa: ID_Empresa,
      })
      .then(function (data) {
        return data.map(function (item) {
          return $schema(item, {
            Vacia: 'boolean',
            ID_Nomifan: 'boolean',
          })
        })
      });
  }

  function guardar(idEmpresa, idNomina, data) {
    return $api.post('kendu/nominas/detalladoNomina/suministro/guardar', {
      ID_Empresa: idEmpresa,
      ID_Nomina: idNomina,
      Nominas: data,
    }, {clearCache: 'nominas' + idNomina});
  }
}



// WEBPACK FOOTER //
// ./src/nominas/carganominaasalariados/services/NominasCargaNominaAsalariados.js